import {getUsers} from '../api/getUsers';
import {setUsersAction} from '../action';

const setUsers = (params) => {
    return async (dispatch, getState) => {
        try {
            const {data} = await getUsers(params);
  
            if (data.status === 'success') {
                dispatch(setUsersAction(data.users));           
            }
          
        } catch(error) {
            if (error && error.response && error.response.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}

export {
    setUsers
}